import React, { ReactElement } from 'react';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  gray40,
  gray80,
  primaryButtonBackgroundColor,
  tertiaryButtonBackgroundColor,
} from '../../../constants/colors';
import { boldMd, regularLg, regularXl } from '../../../constants/location';

type Props = {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  loading?: boolean;
  versionLabel: string;
};

const styles = {
  dialog: {
    '& .MuiPaper-root': {
      border: '1px solid' + gray40,
      boxSizing: 'border-box',
      margin: '16px',
      padding: '40px',
      '@media screen and (max-width: 960px)': {
        padding: '32px 16px',
      },
    },
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
  title: {
    ...regularXl,
    '@media screen and (max-width:960px)': { ...regularLg },
  },
  iconButton: { padding: 0 },
  icon: { height: '32px', width: '32px' },
  buttonWrapper: {
    display: 'flex',
    gap: '16px',
    marginTop: '32px',
  },
  cancelButton: {
    ...tertiaryButtonBackgroundColor,
    height: '44px',
    width: 'calc(50% - 8px)',
  },
  cancelButtonText: { ...boldMd, color: gray80 },
  applyButton: { ...primaryButtonBackgroundColor, height: '44px', width: 'calc(50% - 8px)' },
  applyButtonText: { ...boldMd, color: 'white' },
};

const PatternRollbackConfirmModal = ({
  open,
  onClose,
  onApply,
  loading = false,
  versionLabel,
}: Props): ReactElement => {
  return (
    <Dialog open={open} sx={styles.dialog}>
      <Box sx={styles.header}>
        <Typography sx={styles.title}>{versionLabel} を適用</Typography>
        <IconButton onClick={onClose} sx={styles.iconButton}>
          <Close sx={styles.icon} />
        </IconButton>
      </Box>
      <Typography>
        現在のパターン設定を {versionLabel}{' '}
        の内容で上書きします。新しいバージョンとして履歴に記録され、元のバージョンは履歴に残ります。よろしいですか？
      </Typography>
      <Box sx={styles.buttonWrapper}>
        <Button sx={styles.cancelButton} onClick={onClose} disabled={loading}>
          <Typography sx={styles.cancelButtonText}>キャンセル</Typography>
        </Button>
        <Button sx={styles.applyButton} onClick={onApply} disabled={loading}>
          <Typography sx={styles.applyButtonText}>{loading ? '適用中...' : '適用する'}</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default PatternRollbackConfirmModal;
